import { ProductRepository } from "../Repository/ProductRepository";

export interface ViewMainImageUseCase {
  invoke: (productId: number) => Promise<string | undefined>;
}

export class ViewMainImage implements ViewMainImageUseCase {
  private galeryRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.galeryRepo = _ProductRepo;
  }

   invoke(productId: number){
    if(!productId){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.galeryRepo.viewMainImage(productId);
    return getData;
  }
}